import { useEffect, useRef, useState, ReactNode } from "react"
import cx from "classnames"
import "./Turno.css"

interface TurnoProps {
    folioTurno: string | null
    size?: "normal" | "large"
    showDuration?: number
    isModal?: boolean
    /**
     * Con `showDuration`: indica que `folioTurno` ya trae el estado inicial. El folio que llega
     * en ese momento se muestra una vez y queda como base; después solo se muestra cuando cambia.
     */
    ready?: boolean
    children?: ReactNode
}

export default function Turno({
    folioTurno,
    size = "normal",
    showDuration,
    isModal = false,
    ready = true,
    children,
}: TurnoProps) {
    const [visible, setVisible] = useState(!showDuration)
    // undefined = todavía no se toma el folio base del estado inicial.
    const lastFolioRef = useRef<string | null | undefined>(undefined)

    useEffect(() => {
        if (!showDuration) {
            setVisible(true)
            return
        }
        if (!ready) return

        // El folio inicial se toma como base y también se muestra al entrar; después solo se anuncia
        // cuando llega un folio distinto.
        const esInicial = lastFolioRef.current === undefined
        if (!esInicial && (!folioTurno || folioTurno === lastFolioRef.current)) return

        lastFolioRef.current = folioTurno
        if (!folioTurno) return

        setVisible(true)
        const timer = setTimeout(() => setVisible(false), showDuration)
        return () => {
            clearTimeout(timer)
            setVisible(false)
        }
    }, [folioTurno, showDuration, ready])

    if (!folioTurno || !visible) return null

    const content = (
        <div className={cx("disp__turn-wrapper", { "disp__turn-wrapper--large": size === "large" })}>
            <p className={cx("disp__turn", { "disp__turn--large": size === "large" })}>
                Turno:
                <br />
                <strong>{folioTurno}</strong>
            </p>
            {children && <div className="disp__turn-extra">{children}</div>}
        </div>
    )

    if (isModal) {
        return (
            <div className="modal-turn-overlay">
                <div className="modal-turn-content">{content}</div>
            </div>
        )
    }

    return content
}
